interface GuestCtaButton {
  label: string;
  url: string;
}

export interface GuestUpgradeCtaData {
  title: string;
  body: string;
  primaryAction: GuestCtaButton;
  secondaryAction: GuestCtaButton;
}

interface GuestUpgradeCtaProps {
  title?: string;
  message?: string;
  cta?: GuestUpgradeCtaData | null;
}

export function GuestUpgradeCta({
  title = 'Save your report and track changes',
  message = 'Create an account to explore the core platform, save evidence packs with plan-based retention, and access the audit timeline, drift detection, and exception tracking features.',
  cta,
}: GuestUpgradeCtaProps) {
  return (
    <div className="rounded-lg border border-purple-200 bg-purple-50 p-6">
      <h3 className="text-lg font-semibold text-purple-900 mb-2">{cta?.title || title}</h3>
      <p className="text-purple-800 text-sm mb-4">{cta?.body || message}</p>
      <div className="flex flex-col sm:flex-row gap-3">
        <a
          href={cta?.primaryAction?.url || '/register?source=guest_limit'}
          className="inline-flex items-center justify-center bg-purple-600 text-white px-4 py-2 rounded-md font-semibold hover:bg-purple-700 transition"
        >
          {cta?.primaryAction?.label || 'Create account'}
        </a>
        <a
          href={cta?.secondaryAction?.url || '/pricing?source=guest_limit'}
          className="inline-flex items-center justify-center bg-white text-purple-700 border border-purple-300 px-4 py-2 rounded-md font-semibold hover:bg-purple-100 transition"
        >
          {cta?.secondaryAction?.label || 'View Pricing'}
        </a>
      </div>
    </div>
  );
}
